// const files = require.context('.', true, /\.js$/);
// const modules = {};

// files.keys().forEach((key) => {
//     const moduleName = key.replace(/(\.\/|\.js)/g, ''); // Remove dot in file name
//     if (moduleName !== 'index') {
//         modules[moduleName] = files(key).default;
//     }
// });

// export default modules;

import content from './content';
import client from './client';
import publish from './publish';
import quicklink from './quicklink';
import blobs from './blobs';
import context from './context';
import section from './section';
import health from './health';
import settings from './settings';

export {
    content,
    client,
    publish,
    quicklink,
    blobs,
    context,
    section,
    health,
    settings,
};



// WEBPACK FOOTER //
// ./src/api/index.js